export enum AccessLevelLabels {
  USER = 'User',
  ADMIN = 'Admin',
  PARTNER = 'Partner',
  BIO_BANK_ADMIN = 'Biobank',
  DATA_SCIENCE_ADMIN = 'Data Science',
  SUPER_ADMIN = 'Super Admin',
}
